export default __webpack_public_path__ + "static/media/MockQuestions.dd9fb9e7.png";